<div class="EngravingTypeContainer Grid Gap--normal" [class.Expanded]="!!selectedEngravingType()">
  <div class="TypeContainer Flexbox Gap--normal Align--center">
    <mat-card class="TypeCard" [class.Selected]="selectedEngravingType() === null">
      <mat-card-content>
        <button mat-flat-button (click)="selectEngravingType(null)">
          <div class="Flexbox Align--center Justify--center ButtonContent">
            <span>No Engraving</span>
            <!-- <app-selection-indicator [isVisible]="selectedEngravingType() === null" [shouldAnimate]="shouldAnimateSelection"></app-selection-indicator> -->
          </div>
        </button>
      </mat-card-content>
    </mat-card>
    <mat-card *ngFor="let engravingType of engravingTypes()" class="TypeCard" [class.Selected]="selectedEngravingType()?.id === engravingType.id">
      <mat-card-content>
        <button mat-flat-button (click)="selectEngravingType(engravingType)">
          <div class="Flexbox Align--center Justify--center ButtonContent">
            <span [ngStyle]="getStyle(engravingType.displayName)">{{ engravingType.displayName }}</span>
            <!-- <app-selection-indicator [isVisible]="selectedEngravingType() === engravingType" [shouldAnimate]="shouldAnimateSelection"></app-selection-indicator> -->
          </div>
        </button>
      </mat-card-content>
    </mat-card>
  </div>
  <mat-card class="EngravingTextCard" *ngIf="shouldShowText()" [class.AnimateIn]="shouldAnimateEngravingTextIn" [class.AnimateOut]="shouldAnimateEngravingTextOut">
    <mat-card-content>
      <div [formGroup]="formGroup" class="Flexbox Flexbox--column Justify--center Gap--normal EngravingTextContentWrapper">
        <div class="Flexbox Justify--space-between">
          <div class="Flexbox Align--center CharCount" [class.Long]="(formGroup.controls.engravingText.value?.length ?? 0) > 30">
            <p>{{ formGroup.controls.engravingText.value?.length ?? 0 }}</p>
            <p>/</p>
            <p>30</p>
          </div>
        </div>
        <mat-form-field appearance="outline" class="EngravingText">
          <mat-label>Engraving Text</mat-label>
          <textarea matInput cdkTextareaAutosize maxlength="30" cdkAutosizeMaxRows="1" cdkAutosizeMaxRows="5" formControlName="engravingText"></textarea>
          <mat-error *ngIf="formGroup.controls.engravingText.invalid"><span class="FieldError">{{ getError(formGroup.controls.engravingText) }}</span></mat-error>
        </mat-form-field>
        <div class="SpecialCharactersContainer Flexbox Flexbox--column Gap--smaller Align--center Align--flex-start">
          <span>Special characters:</span>
          <div class="Flexbox Gap--smaller">
            <button mat-flat-button><div class="ButtonContent" (click)="appendToEngravingText('{')"><span>&#123;</span></div></button>
            <button mat-flat-button><div class="ButtonContent" (click)="appendToEngravingText('}')"><span class="HeartText">&#125;</span></div></button>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>